if (!customElements.get('product-info')) {
    customElements.define(
        'product-info',
        class ProductInfo extends HTMLElement {
            constructor() {
                super();
                this.input = this.querySelector('.quantity__input');
                this.currentVariant = this.querySelector('.product-variant-id');
                this.submitButton = this.querySelector('[type="submit"]');
            }

            cartUpdateUnsubscriber = undefined;
            variantChangeUnsubscriber = undefined;

            connectedCallback() {
                if (!this.input) return;
                this.input.addEventListener('change', this.input.reportValidity);
                this.quantityForm = this.querySelector('.product-form__quantity');
                if (!this.quantityForm) return;
                this.setQuantityBoundries();
                if (!this.dataset.originalSection) {
                    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
                }
                this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
                    if (event.data.sectionId !== sectionId) return;
                    this.updateQuantityRules(event.data.sectionId, event.data.html);
                    this.setQuantityBoundries();
                });
                this.productForm = this.querySelector('product-form');
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
                if (this.variantChangeUnsubscriber) {
                    this.variantChangeUnsubscriber();
                }
            }

            setQuantityBoundries() {
                const data = {
                    cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
                    min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
                    max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
                    step: this.input.step ? parseInt(this.input.step) : 1
                };

                let min = data.min;
                const max = data.max === null ? data.max : data.max - data.cartQuantity;
                if (max !== null) min = Math.min(min, max);
                if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
                this.input.min = min;

                if (!isNaN(max)) {
                    this.input.max = max === 0 ? 1 : max;
                } else {
                    this.input.removeAttribute('max');
                }
                this.input.value = Math.max(min, 1);
                publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
            }

            fetchQuantityRules() {
                if (!this.currentVariant || !this.currentVariant.value) return;
                this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
                fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
                    .then((response) => {
                        return response.text();
                    })
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, 'text/html');
                        this.updateProductInfo(this.dataset.section, html);
                        this.updateQuantityRules(this.dataset.section, html);
                        this.updateAddToCartButtons(this.dataset.section, html);
                        this.setQuantityBoundries();
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
                    });
            }

            updateProductInfo(sectionId, html) {
                const productInfoUpdated = html.getElementById(`ProductInfo-${sectionId}`);
                if (!productInfoUpdated) return;
                const selectors = [
                    `#Multibottles-${sectionId}`,
                    `#MultibottlesMin-${sectionId}`,
                    `#MultibottlesMed-${sectionId}`,
                    `#MultibottlesMax-${sectionId}`,
                    `#Inventory-${sectionId}`,
                    `#PreorderInfo-${sectionId}`,
                    `#MultipleLocation-${sectionId}`
                ];
                for (let selector of selectors) {
                    const current = this.querySelector(selector);
                    const updated = productInfoUpdated.querySelector(selector);
                    if (!current || !updated) continue;
                    // Update multiple buttons blocks
                    if (selector === `#Multibottles-${sectionId}` ||
                        selector === `#MultibottlesMin-${sectionId}` ||
                        selector === `#MultibottlesMed-${sectionId}` ||
                        selector === `#MultibottlesMax-${sectionId}`
                    ) {
                        const attributes = ['style'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) {
                                current.setAttribute(attribute, valueUpdated);
                            } else {
                                current.removeAttribute(attribute);
                            }
                        }
                    // Update PreOrder Info blocks
                    // Update selling from multiple locations
                    } else if( selector === `#PreorderInfo-${sectionId}` ||
                               selector === `#MultipleLocation-${sectionId}`
                    ){
                        const attributes = ['style'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) {
                                current.setAttribute(attribute, valueUpdated);
                            } else {
                                current.removeAttribute(attribute);
                            }
                            current.innerHTML = updated.innerHTML;
                        }
                    } else {
                        current.innerHTML = updated.innerHTML;
                    }
                }
            }

            updateAddToCartButtons(sectionId, html) {
                const productFormUpdated = html.querySelector(`product-form[data-section-id=${sectionId}]`);
                if (!productFormUpdated) return;
                const selectors = [`#ProductSubmitButton-${sectionId}`, '.back-in-stock-button-wrapper'];
                for (let selector of selectors) {
                    const current = this.productForm.querySelector(selector);
                    const updated = productFormUpdated.querySelector(selector);
                    if (!current || !updated) continue;
                    if (selector === `#ProductSubmitButton-${sectionId}`) {
                        const attributes = ['class', 'disabled', 'style'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) {
                                current.setAttribute(attribute, valueUpdated);
                            } else {
                                current.removeAttribute(attribute);
                            }
                        }
                    }
                    if (selector === '.back-in-stock-button-wrapper') {
                        const attributes = ['enabled', 'style'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) {
                                current.setAttribute(attribute, valueUpdated);
                            } else {
                                current.removeAttribute(attribute);
                            }
                        }
                    }
                }
            }

            updateQuantityRules(sectionId, html) {
                const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
                // Update container style, in case product pass from available, to not available ( considering inventory stock and preoprder )
                const updateQuantityFormUpdatedStyle = quantityFormUpdated.getAttribute('style');
                this.quantityForm.setAttribute('style', updateQuantityFormUpdatedStyle);

                const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label', '.product-form__buttons'];
                for (let selector of selectors) {
                    const current = this.quantityForm.querySelector(selector);
                    const updated = quantityFormUpdated.querySelector(selector);
                    if (!current || !updated) continue;
                    if (selector === '.quantity__input') {
                        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step', 'style'];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) {
                                current.setAttribute(attribute, valueUpdated);
                            } else {
                                current.removeAttribute(attribute);
                            }
                        }
                    } else {
                        current.innerHTML = updated.innerHTML;
                    }
                }
            }
        }
    );
}
